<template>
    <div class="ProviderAppointmentBlocks">
        <h2><i class="fa fa-calendar" /> Appointment Blocks <span v-b-tooltip.hover title="New Block" style="float:right;" @click="ShowAddBlock"><i class="fa fa-plus olive-green-text pointer" /></span></h2>
        <div class="row">
            <div class="col-md-3">
                <i class="fa fa-square" style="color: #94A545;" /> Assessment Available
            </div>
            <div class="col-md-3">
                <i class="fa fa-square" style="color: #007bff; " /> Follow-Up Available
            </div>
            <div class="col-md-3">
                <i class="fa fa-square" style="color: #a30000;" /> Fully Booked
            </div>
        </div>
        <FullCalendar ref="calendar" :options="CalendarOptions" />

        <Slideout dock="right" :visible.sync="DetailVisible" title="Appointment Block">
            
        </Slideout>
        <b-sidebar v-model="DetailVisible" title="Appointment Block" right shadow backdrop width="100%">
            <ProviderAppointmentBlockDetail ref="detailview" />
        </b-sidebar>

    </div>
</template>

<script>
    import FullCalendar from '@fullcalendar/vue';
    import dayGridPlugin from '@fullcalendar/daygrid';
    import timeGridPlugin from '@fullcalendar/timegrid';
    import interactionPlugin from '@fullcalendar/interaction';

    

    import GenericDataTable from '../../Core/UI/GenericDataTable.vue';
    import ProviderAppointmentBlockDetail from './ProviderAppointmentBlockDetail.vue';

    export default {
        name: "ProviderAppointmentBlocks",
        data: function () {
            return {
                Records: [
                ],
                
                DetailVisible: false,
            };
        },
        methods: {
            ShowAddBlock() {
                this.$refs["detailview"].SetNew();
                this.DetailVisible = true;
            },
            LoadBlockDetail(eventId) {
                this.$refs["detailview"].ShowDetail(eventId);
            },
            HideBlockDetail() {
                this.DetailVisible = false;
            },
            ShowBlockDetail() {
                this.DetailVisible = true;
            },
            LoadData() {
                let calAPI = this.$refs['calendar'].getApi();
                calAPI.refetchEvents();
            },
            HandleEventClick(e) {
                this.LoadBlockDetail(e.event.id);
            }
        },
        components: {
            GenericDataTable,
            ProviderAppointmentBlockDetail,
            FullCalendar
        },
        mounted() {

        },
        computed: {
            CalendarOptions: function () {
                let vm = this;
                let initialOptions = {
                    plugins: [timeGridPlugin, interactionPlugin, dayGridPlugin],
                    initialView: "dayGridMonth",
                    editable: true,
                    allDaySlot: false,
                    //slotMinTime: "00:00:00",
                    //slotMaxTime: "23:59:00",
                    //contentHeight: 1200,
                    height: 800,
                    //selectable: true,
                    //allDaySlot: true,
                    //select: this.HandleSelect,
                    eventClick: vm.HandleEventClick,
                    //eventResize: this.HandleEventResize,
                    //eventDrop: this.HandleEventDrop,
                    //events: '/API/Wraparound/ClientAppointments/GetMyAppointments',
                    eventSources: [
                        {
                            url: '/API/MentalHealth/Appointments/ProviderAppointmentBlocks',
                            extraParams: {}
                        }
                    ],
                    eventSourceSuccess: function (content, xhr) {
                        vm.Records = content.data;
                        return content.data;
                    }
                };

                return initialOptions;
            },
        }
    }
</script>